<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_4"></h2>
<p class="firstcenter">To my dad,<br/>
<span class="b-i">Vaughan Palmore,</span></p>
<p class="firstcenter">and my husband,<br/>
<span class="b-i">Randy Morse,</span></p>
<p class="firstcenter">two men who have inspired me with their lives of prayer.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?fb25c404